import { Component, OnInit, OnChanges, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ProfileService } from '../../profile.service';
import { MatDialog } from '@angular/material/dialog';
import { ApiService } from '../../api.service';
import * as CryptoJS from 'crypto-js';
import { DialogOverviewConfirmationComponent } from '../../dialog-overview-confirmation/dialog-overview-confirmation.component';

@Component({
  selector: 'lib-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit, OnChanges {
  hide = true;
  hide1= true;
  dataToPass;
  passwordForm: FormGroup;
  submitted: boolean = false;
  otpSubmitted: boolean = false;
  showLableView:boolean=false;
  confirmPassword: boolean = false;
  confirmPasswordVal;
  timeLeft: number = 90;
  otpView:boolean = false;
  @ViewChild('otpModel') otpModel;
  interval;
  submitShow:boolean=true;
  showResend:boolean=false;
  @ViewChild('confirmPasswordModel') confirmPasswordModel;
  public barLabel: string = "Strength:";
  tokenKey: string;
  @Input() clientId;
  @Input() clientSecret;
  @Input() passAppList;
  userInfo:any;
  @Input() logOutUrl;
  @Input() userprinciplename;
  hideAll:boolean=true;
  showButton:boolean=false;
  otpval:any;
  accountDeleted: boolean = false;
  @Output() dataEvent = new EventEmitter();
  public strengthLabels = ['Too Weak', 'Weak', 'Fair', 'Good', 'Strong'];
  constructor(private userService: ProfileService,
    public dialog: MatDialog, 
    private formbuilder: FormBuilder,
    private apiService: ApiService) { }

  ngOnInit() {
    this.passwordForm = this.formbuilder.group({
      currentPassword: ["", Validators.required],
      newPassword: ['',  Validators.compose([
        Validators.required,
        Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$#!%*?&])[A-Za-z\d@$#!%*?&]{8,}$/)
      ])],
    })
  }
  ngOnChanges(){
    if(this.passAppList){
      this.userInfo = this.passAppList;
    }
  }
  get f() {
    return this.passwordForm.controls;
  }
  encryptUsingAES256(data:any) {
    let _key = CryptoJS.enc.Utf8.parse(this.apiService.tokenKey);
    let _iv = CryptoJS.enc.Utf8.parse(this.apiService.tokenKey);
    let encrypted = CryptoJS.AES.encrypt(
      data, _key, {
        keySize: 128 / 8,
        iv: _iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });
    return encrypted.toString();
  }
  changePassword() {
    const dialogRef = this.dialog.open(DialogOverviewConfirmationComponent, {
      width: '500px',
      disableClose: true
    });
    this.dataToPass = {
      changePass:true
    };
    dialogRef.componentInstance.confirmData = this.dataToPass;
    dialogRef.afterClosed().subscribe(result => {
      if(result.event === 'confirm'){
        this.changeUpdatedPassword();
      }
    });
  }
  passwordFun(){
    this.submitted = true;
    if (this.passwordForm.invalid){
      return;
    }
    if (this.confirmPasswordModel.invalid) {
      return false;
    }
    if(this.passwordForm.value.newPassword != this.confirmPasswordVal) {
      this.confirmPassword = true; 
      return;
    } else {
      this.confirmPassword = false;
    }
     this.sendOtp();
  }
  showStrengthLable(e:string){
    if(e.length > 0){
      this.showLableView = true;
    } else {
      this.showLableView = false;
    }
    if(this.passwordForm.value.newPassword == this.confirmPasswordVal) {
      this.confirmPassword = false;
    }
  }
  changeUpdatedPassword(){
    var data = {
      username: this.userprinciplename,
      oldPassword: this.encryptUsingAES256(this.passwordForm.value.currentPassword),
      newPassword: this.encryptUsingAES256(this.passwordForm.value.newPassword),
      clientId: this.clientId,
      clientSecret: this.clientSecret
     }
     this.apiService.changePassword(data).subscribe({
      next: res => {
        if(res) {
          this.passwordForm.reset();
          this.confirmPasswordVal = "";
          this.submitted=false;
          this.hide = true;
          this.hide1= true;
          this.dataEvent.emit({event:'changePasswordSuccess'});
          this.showLableView = false;
          setTimeout(() => {
            this.userService.logout();
            window.location.href  = this.logOutUrl;
          }, 2000);
        } else {
          this.passwordForm.reset();
          this.confirmPasswordVal = "";
          this.showLableView = false;
          this.submitted=false;
          this.dataEvent.emit({event:'changePasswordFailure'})
        }
      },
      error: err => {
        if(err.error.message != ''){
          this.passwordForm.reset();
          this.showLableView = false;
          this.confirmPasswordVal = "";
          this.submitted=false;
          this.hide = true;
          this.hide1= true;
          this.dataEvent.emit({event:'error',message:err.error.error_code})
        }
      }
    })
  }
  sendOtp(){
    this.showResend = false;
    this.apiService.generateUserOTP(localStorage.getItem('user_token')).subscribe({
      next: (data: any) => {
        this.hideAll = true;
        this.otpView = true;
        this.showButton = false;
        this.submitShow = false;
        this.timeLeft = 90;
        this.dataEvent.emit({event:'deleteAccount'})
       this.startTimer();
      },
      error: err => {
        this.hideAll = false;
       },
      complete: () => { }
    })
  }
  resend(){
    this.otpSubmitted = true;
    var attributeInvalid = false;
    if (this.otpModel.invalid) {
      attributeInvalid = true;
      return false;
    }
    const formData = {
      username: this.userprinciplename,
      oldPassword: this.encryptUsingAES256(this.passwordForm.value.currentPassword),
      newPassword: this.encryptUsingAES256(this.passwordForm.value.newPassword),
      otp:this.otpval
     }
    this.apiService.changePasswordRequest(formData).subscribe({
      next: (data: any) => {
       if(data){
        this.dataEvent.emit({event:'suceessChange'});
        this.userService.logout();
        window.location.href  = this.logOutUrl;
       }else {
        this.dataEvent.emit({event:'failureChange'});
       }
      },
      error: err => { 
        if(err.error.message != ''){
          this.dataEvent.emit({event:'error',message:err.error.error_code})
        }
      },
      complete: () => { }
    })
  }
  startTimer() {
    this.interval = setInterval(() => {
      if(this.timeLeft > 0) {
        this.timeLeft--;
      } else {
        this.showResend = true;
        this.submitShow = false;
        this.showButton = true;
        clearInterval(this.interval);
      }
    },1000)
  }
}
